import { gql } from '@apollo/client';
import { Commande } from '../../fragments/commande/commande.fragments';
import { Classe } from '../../fragments/classe/classe.fragments';

const QUERY_LAST_COMMANDE = gql`
  query getLastEleveCommande($id: ID!) {
    usersPermissionsUser(id: $id) {
        data {
            attributes {
                commandes(sort: "createdAt:desc", pagination: {limit:1}) {
                    data {
                        attributes {
                            ...DetailsCommande
                            user {
                                data {
                                    attributes {
                                        lastname
                                        firstname
                                        email
                                        classes {
                                            data {
                                                attributes {
                                                    ...ClasseInfo
                                                }
                                            }
                                        }
                                    }
                                }
                             
                            }
                        }
                    }
                
                }

            }
        }
    }
  }
  ${Commande.fragments.detailsCommande},
  ${Classe.fragments.info},
`;
export default QUERY_LAST_COMMANDE;
